export type MonthViewMode = 'year' | 'rolling';
export type RollingMonthValueType = 'actual' | 'forecast';
export type RollingMonthKey = 'w1' | 'w2' | 'w3' | 'w4' | 'w5' | 'w6' | 'w7';
export type SummaryKey = 'ttl' | 'ytd' | 'ytg' | 'q1' | 'q2' | 'q3' | 'q4' | 'h1' | 'h2';

export interface RollingMonthColumn {
  key: RollingMonthKey;
  title: string;
  targetMonth: string;
  valueType: RollingMonthValueType;
  forecastWindow: boolean;
}

const ROLLING_MONTH_OFFSETS = [-1, 0, 1, 2, 3, 4, 5] as const;
const YEAR_SUMMARY_KEYS: SummaryKey[] = ['ttl', 'ytd', 'ytg', 'q1', 'q2', 'q3', 'q4', 'h1', 'h2'];

const padMonth = (month: number) => String(month).padStart(2, '0');

const parseBizMonth = (bizDate: string) => {
  const [year, month] = bizDate.slice(0, 7).split('-').map(Number);
  return { year, month };
};

const addMonths = (year: number, month: number, offset: number) => {
  const zeroBased = month - 1 + offset;
  const targetYear = year + Math.floor(zeroBased / 12);
  const normalizedMonth = ((zeroBased % 12) + 12) % 12;
  return {
    year: targetYear,
    month: normalizedMonth + 1,
  };
};

export const buildRollingMonthColumns = (bizDate: string): RollingMonthColumn[] => {
  const { year, month } = parseBizMonth(bizDate);

  return ROLLING_MONTH_OFFSETS.map((offset, index) => {
    const target = addMonths(year, month, offset);
    const targetMonth = `${target.year}-${padMonth(target.month)}`;
    return {
      key: `w${index + 1}` as RollingMonthKey,
      title: targetMonth,
      targetMonth,
      valueType: offset < 0 ? 'actual' : 'forecast',
      forecastWindow: offset >= 0,
    };
  });
};

export const getVisibleSummaryKeys = (mode: MonthViewMode): SummaryKey[] => (mode === 'year' ? YEAR_SUMMARY_KEYS : []);
